/**
 * Display helpers for the Roles & Org settings surface (ADR-0030).
 * The permission catalog itself is imported live from `@flint/api-contract`.
 */

/** Human label for a permission area key. */
export const AREA_LABELS: Record<string, string> = {
  sales: "Sales",
  purchases: "Purchases",
  money: "Money & banking",
  compliance: "Compliance & reports",
  garment: "Garment",
  people: "People & payroll",
  admin: "Administration",
};

const ACTION_LABELS: Record<string, string> = {
  view: "View",
  create: "Create",
  issue: "Issue",
  send: "Send",
  void: "Void",
  raise: "Raise",
  record: "Record",
  manage: "Manage",
  approve: "Approve",
  lock: "Lock",
  issue_to: "Issue",
  run: "Run",
  edit: "Edit",
  confirm: "Confirm",
  export: "Export",
};

/** Split `resource.action` (or `garment.qc.record`) into a {resource, action}. */
export function splitPermission(p: string): { resource: string; action: string } {
  const parts = p.split(".");
  const action = parts.at(-1) ?? p;
  return { resource: parts.slice(0, -1).join("."), action };
}

/** "garment.qc.record" → "QC — Record"; "invoices.create" → "Invoices — Create". */
export function permissionLabel(p: string): string {
  const { resource, action } = splitPermission(p);
  const res = resource.split(".").at(-1) ?? resource;
  const resWord = res.charAt(0).toUpperCase() + res.slice(1).replace(/([A-Z])/g, " $1");
  const actWord = ACTION_LABELS[action] ?? action.charAt(0).toUpperCase() + action.slice(1);
  return `${resWord} — ${actWord}`;
}
